import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FestivalService, { FestivalDetail } from "@/app/_services/FestivalService";

export function useFestivalDetailModel() {
  const { festival_id } = useParams<{ festival_id: string }>();
  const [data, setData] = useState<FestivalDetail | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  function loadFestivalDetail() {
    if (!festival_id) return;
    setIsLoading(true);
    FestivalService.getFestivalDetailAsync(festival_id)
      .then(setData)
      .finally(() => setIsLoading(false));
  }

  useEffect(() => {
    loadFestivalDetail();
  }, [festival_id]);

  return {
    festivalId: festival_id,
    data,
    isLoading,
    refetch: loadFestivalDetail,
  };
}
